// extracted by mini-css-extract-plugin
export default {"menuButton":"src-views-common-components-CompositeSnapMenu-CompositeSnapMenu__menuButton--fqfV2"};